import React from "react";

export default function Footer() {
  return (
    <>
      <footer>
        <div className="p-2 d-flex flex-row align-items-center justify-content-center">
          <p>
            Built by Sue Brechko. See you on{" "}
            <a
              href="https://github.com/shoproizoshlo/portfolio"
              target="_blank"
              rel="noreferrer"
              title="github page - Susanna"
            >
              GitHub
            </a>
          </p>
        </div>
      </footer>
    </>
  );
}
